import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { InsuranceCoverageMonitor } from "../../../../../../services/api/insurance/monitor/types";
import { getRequirementDefinitionTableCellProps } from "../../../../../RequirementDefinitions/utils";
import {
  CellsConfig,
  ContextItem,
  RequirementTableCallback
} from "../../../../types";
import { getRegistrationRequirementName } from "../helpers/getRegistrationRequirementName";
import { getRegistrationRequirementPayerStatusCell } from "../helpers/getRegistrationRequirementPayerStatusCell";

export const usePayerRegistrationConfig = (
  _: RequirementTableCallback
): CellsConfig<
  IRequirementResponse,
  ContextItem,
  InsuranceCoverageMonitor | undefined
> => {
  return {
    isActionRequired: () => false,

    requirementName: getRegistrationRequirementName,

    toolbarActions: () => [],

    nameCell: requirement => ({
      text: getRegistrationRequirementName(requirement)
    }),

    typeCell: requirement =>
      getRequirementDefinitionTableCellProps({
        type: requirement.requirementType
      }),

    statusCell: getRegistrationRequirementPayerStatusCell
  };
};
